// ANCHOR Models
import { useFormSubmissionQuestionItemQuestion } from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';
import { FormQuestionAnswersForStudentData } from '@lyon/scoped-models/form/FormQuestionAnswersDataForStudent';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormMultipleChoice } from './LyonViewAnswerFormMultipleChoice';
import { LyonViewAnswerFormShortAnswer } from './LyonViewAnswerFormShortAnswer';
import { LyonViewAnswerFormEssay } from './LyonViewAnswerFormEssay';
import { LyonViewAnswerFormAttachment } from './LyonViewAnswerFormAttachment';
import { LyonViewAnswerFormCheckbox } from './LyonViewAnswerFormCheckbox';

export const LyonViewAnswerFormQuestionItemAnswer = constant(() => {
  const [id, type] = useFormSubmissionQuestionItemQuestion();

  if (!type || !id) {
    return <Loader />;
  }

  switch (type) {
    case 'multiple_choice': {
      return (
        <FormQuestionAnswersForStudentData.Provider id={id} type={type}>
          <LyonViewAnswerFormMultipleChoice />
        </FormQuestionAnswersForStudentData.Provider>
      );
    }
    case 'checkbox_answer': {
      return (
        <FormQuestionAnswersForStudentData.Provider id={id} type={type}>
          <LyonViewAnswerFormCheckbox />
        </FormQuestionAnswersForStudentData.Provider>
      );
    }
    case 'short_answer': {
      return <LyonViewAnswerFormShortAnswer />;
    }
    case 'essay': {
      return <LyonViewAnswerFormEssay />;
    }
    case 'attachment': {
      return (
        <LyonViewAnswerFormAttachment />
      );
    }
    case 'spacer':
    default:
      return null;
  }
});
